import { Box, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Container = styled.div`
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const SubtitleText = styled.div`
  color: var(--background-white-n-0, #fff);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 25px;
`;

export const CarModelText = styled.div`
  color: var(--Text-White, #fff);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  margin-top: 4px;
`;

export const CarImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px;
`;

export const PriceCard = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.62);
  padding: 24px;
  margin-bottom: 80px;
  position: relative;
  @media (min-width: 768px) {
    max-width: 320px;
    margin: 20px auto;
  }
`;

export const DeliveryBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 32px;
  border: 1px solid #828282;
  background: linear-gradient(98deg, #212121 7.16%, #2a2a2a 95.82%);
  padding: 4px 16px;
  gap: 8px;
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translate(-50%, 0);
  width: max-content;
`;

export const DeliveryText = styled.div`
  color: var(--background-white-n-0, #fff);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
`;

export const LocationText = styled.div`
  color: var(--Neutral-N200, #e7e7f0);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const PriceText = styled.div`
  color: var(--Text-White, #fff);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.5px;
`;

export const MarketPriceText = styled.div`
  color: var(--Yellow-Y200, #ffc400);
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const CallbackContainer = styled.div`
  width: 100%;
  background: #fff
`;

export const CallBackHeader = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
`;

export const CallBackText = styled(Text)`
  color: var(--text-secondary-n-400, #5B5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
